import React from 'react';

export default function DashboardHome() {
    return (
        <div className="dashboard-home">
            <h1>Welcome to Admin Dashboard</h1>
            {/* Add your dashboard overview content here */}
        </div>
    );
} 